/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import { fade, makeStyles, TextField, Grid } from "@material-ui/core";
import { IconTooltip } from "../../icons/IconTooltip";
import { ViewModeTextField } from "./ViewModeTextField";

const useStylesInput = makeStyles(theme => ({
  root: {
    "label + &": {
      marginTop: "5px"
    }
  },
  labelRequired: {
    color: "#f75676",
    marginLeft: "4px",
    fontSize: "12px",
    paddingTop: 1
  },
  labelRequiredComments: {
    color: "#f75676",
    marginLeft: "4px",
    fontSize: "12px",
    marginBottom: "4px",
    marginTop: "5px"
  },
  iconInfo: {
    width: "16px !important",
    height: "16px !important",
    color: "#32325d",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  commentBox: {
    marginTop: "20px",
    "& label": {
      width: "100%",
      "& div": {
        "& input": {
          marginBottom: "20px"
        }
      }
    }
  },
  labelInformation: {
    fontSize: 12,
    fontWeight: 600,
    color: "#8897aa",
    height: "14px",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  input: {
    borderRadius: 4,
    position: "relative",
    borderColor: "#cad1d7",
    border: "1px solid #cad1d7",
    fontSize: 14,
    padding: "13px 14px",
    color: "#323536",
    alignSelf: "flex-end",
    transition: theme.transitions.create(["box-shadow"]),
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      "text-decoration-line": "none"
    }
  }
}));

export const TextFieldV1 = (props: any) => {
  const classes = useStylesInput();
  const {
    infoIconData,
    required,
    label,
    error,
    styles,
    onBlur,
    value,
    defaultValue,
    viewModeStyle,
    isViewMode,
    inputLabelStyles,
    onChange
  } = props;
  return isViewMode ? (
    <ViewModeTextField
      label={label}
      style={viewModeStyle}
      infoIconData={infoIconData}
      value={value}
    />
  ) : (
    <TextField
      value={value}
      defaultValue={defaultValue}
      InputProps={{ classes }}
      label={(
        <Grid container className={classes.labelContainer}>
          <Grid item xs={12} md={12} sm={12}>
            <span className={classes.labelInformation}>{label}</span>
            {required ? (
              <span className={classes.labelRequired}>
                <sup>*</sup>
              </span>
            ) : null}
          </Grid>
          {infoIconData ? (
            <IconTooltip topic="Information" infoIconData={infoIconData} />
          ) : null}
        </Grid>
      )}
      InputLabelProps={{
        style: {
          position: "relative",
          fontWeight: 600,
          fontSize: 12,
          color: "#32325d",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...inputLabelStyles
        }
      }}
      error={error}
      inputProps={{
        style: { borderColor: error ? "#f75676" : "#cad1d7" }
      }}
      style={{
        flex: 1,
        width: "100%",
        ...styles
      }}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};
